import axios from "axios";

// Empty/undefined = same-origin. Non-empty = absolute base URL (used e.g. in
// dev when frontend is on :3000 and backend elsewhere).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "quantzillion_session_token";

export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  withCredentials: true,   // still sends cookie when same-origin
});

// Attach Bearer token from localStorage on every request — enables cross-origin
// setups (e.g. frontend on Lightsail, backend on Emergent) where third-party
// cookies are blocked by the browser.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
